import { getPreloadedState } from './get-preloaded-state';

export default () => {
    const preloadedState = getPreloadedState();
    const cloudAPIUrl = preloadedState?.config?.yaServices.cloudAPIUrl;

    return cloudAPIUrl || 'https://cloud-api.yandex.ru';
};
